import * as Environment from "../base/Environment.js";
import {RenderContext, Stage, AnimatableSprite} from "../base/Display2D.js";

import {Site} from "./Site.js";

//
// Navigation extends Stage
//

export const Navigation = function (context) {
	Stage.apply (this, arguments);
	
	if (Navigation.sharedInstance)
		throw new Error ("Cannot instantiate. Navigation is singleton.");
	
	Navigation.sharedInstance = this;
	
	var element = this.element;
	element.style.visibility = "";
	element.classList.add ("unselectable");
	
	this.setUpContent ();
	
	this.addListener ("resize", this.resize, this);
	this.resize ();
	
	if (Environment.FAST_PASS) {
		/*
		window.setTimeout (function () {
			this.toggleMenu ();
			
		}.bind (this), 250);
		
		window.setTimeout (function () {
			this.toggleMenu ();
			
		}.bind (this), 1250);
		*/
		
		/*
		window.setTimeout (function () {
			this.toggleSearch ();
			
		}.bind (this), 250);
		*/

	}
	
};

Navigation.prototype = Object.create (Stage.prototype);

Navigation.prototype.setUpContent = function () {
	const element = this.element
	
	const mobileNavigation = this.mobileNavigation = element.parentNode.querySelector (".mobile-navigation");
	const mobileNavigationContent = mobileNavigation.firstElementChild.firstElementChild.firstElementChild;

	const mobileNavigationSeparator = this.mobileNavigationSeparator = document.createElement ("div");
	mobileNavigationSeparator.classList.add ("mobile-navigation--separator");
	mobileNavigation.appendChild (mobileNavigationSeparator);
	
	const mainNavigation = this.mainNavigation = element.querySelector (".main-navigation");
	mobileNavigationContent.appendChild (mainNavigation.cloneNode (true));
	
	const languageSwitch = element.querySelector (".page-tool-language");
	mobileNavigationContent.appendChild (languageSwitch.cloneNode (true));
	
	
	const menuButton = this.menuButton = element.querySelector (".page-tool-menu");
	menuButton.addEventListener ("click", this.toggleMenu.bind (this));
	
	const searchField = this.searchField = element.querySelector (".search-field");
	
	const searchButton = this.searchButton = element.querySelector (".page-tool-search");
	if (searchButton)
		searchButton.addEventListener ("click", this.toggleSearch.bind (this));
	
	
	const headerLogo = this.headerLogo = element.querySelector (".header--logo");
	const pageTools = this.pageTools = element.querySelector (".page-tools");
	
};

Navigation.prototype.resizeContext = function (context) {
	this.setSize (
		Environment.IS_TOUCH_DEVICE ?
			RenderContext.getViewportSize () :
			this.getRulerSize ()
		
	);
	
};

Navigation.prototype.resize = function (sender) {
	this.isResizing = true;
	
	var viewSize = this.viewSize = this.size;
	
	this.updateSearchFieldLayout ();
	this.scroll ();
	
	this.isResizing = false;
	
};

Navigation.prototype.scroll = function (sender) {
	
};

Navigation.prototype.renderSelfInContext = function () {
	
};

Navigation.prototype.toggleMenu = function (event) {
	if (this.isSearching) {
		this.toggleSearch ();
		return;
		
	}
	
	const isOpen = this.isOpen = !this.isOpen;
	
	const element = this.element;
	
	const mobileNavigation = this.mobileNavigation;
	mobileNavigation.style.display = "block";
	mobileNavigation.style.height = "";
	
	if (isOpen) {
		element.classList.add ("open");
		
		this.expandedHeight = mobileNavigation.offsetHeight;
		this.startAnimation ("Expansion", {direction: 1, rate: .04});
		
	} else {
		element.classList.remove ("open");
		
		this.expandedHeight = mobileNavigation.offsetHeight;
		this.startAnimation ("Expansion", {direction: 0, rate: .04});
		
	}
	
};

Navigation.prototype.animateExpansion = function () {
	const state = this.updatedState ("Expansion");
	let t = state.phase;
	
	const mobileNavigation = this.mobileNavigation;
	
	mobileNavigation.style.display = t == 0 ? "none" : "block";
	
	this.mobileNavigationSeparator.style.opacity = (t - .25) / (1 - .25);
	
	if (t == 0) {
		
	} else if (t < 1) {
		t = .5 - Math.cos (t * Math.PI) * .5;
		t = .5 - Math.cos (t * Math.PI) * .5;
		
		const height = Math.round (
			this.expandedHeight * t
			
		);
		
		mobileNavigation.style.overflow = "hidden";
		mobileNavigation.style.height = height + "px";
		
	} else {
		mobileNavigation.style.overflow = "";
		mobileNavigation.style.height = "";
		
	}
	
};

Navigation.prototype.toggleSearch = function (event) {
	if (this.isOpen)
		this.toggleMenu ();
	
	const isSearching = this.isSearching = !this.isSearching;
	
	const element = this.element;
	
	if (isSearching) {
		element.classList.add ("searching");
		this.startAnimation ("SlideSearchField", {direction: 1, rate: .04});
		this.searchField.querySelector('input').focus ()
		
	} else {
		element.classList.remove ("searching");
		this.startAnimation ("SlideSearchField", {direction: 0, rate: .04});
		
	}
	
};

Navigation.prototype.animateSlideSearchField = function () {
	const state = this.updatedState ("SlideSearchField");
	this.updateSearchFieldLayout ();
	
};

Navigation.prototype.updateSearchFieldLayout = function () {
	const state = this.states ["SlideSearchField"];
	if (!state)
		return;
	
	let t = state.phase;
	
	const searchField = this.searchField;
	searchField.style.display = t == 0 ? "none" : "block";
	
	const column = searchField.parentNode.parentNode;
	const columnBounds = column.getBoundingClientRect ();
	
	const headerLogo = this.headerLogo;
	const headerLogoBounds = headerLogo.getBoundingClientRect ();
	
	const pageTools = this.pageTools;
	const pageToolsBounds = pageTools.getBoundingClientRect ();
	
	let leftBound, rightBound;
	let logoWidth;
	
	const viewSize = this.size;
	
	t = .5 - Math.cos (t * Math.PI) * .5;
	t = .5 - Math.cos (t * Math.PI) * .5;
		
	const t_ = 1 - t;
	
	if (viewSize [0] > 767.98) {
		rightBound = pageToolsBounds.left - columnBounds.left - 10;
		
		const mainNavigation = this.mainNavigation;
		
		if (viewSize [0] > 1199.98) {
			const firstNavigationItemBounds = mainNavigation.firstElementChild.firstElementChild.getBoundingClientRect ();
			
			leftBound = firstNavigationItemBounds.left - columnBounds.left;
			
		} else {
			const secondNavigationItemBounds = mainNavigation.firstElementChild.firstElementChild.nextElementSibling.getBoundingClientRect ();
			
			leftBound = Math.max (
				secondNavigationItemBounds.left - columnBounds.left - 17,
				headerLogoBounds.right - columnBounds.left + 37
				
			);
			
		}
		
	} else {
		leftBound = headerLogoBounds.left - columnBounds.left - 15;
		rightBound = pageToolsBounds.left - columnBounds.left + 23;
		
		logoWidth = headerLogo.firstElementChild.offsetWidth;
		logoWidth = Math.min (
			logoWidth,
			logoWidth * t_ * (viewSize [0] < 480 ? 1.25 : 1.5)
			
		);
		
	}
	
	searchField.style.left = Math.round (leftBound * t + rightBound * t_) + "px";
	searchField.style.right = Math.round (columnBounds.width - rightBound) + "px";
	
	headerLogo.style.width = logoWidth == undefined ?
		"" :
		Math.round (logoWidth) + "px";
	
};
